import { createReducer } from '@reduxjs/toolkit';
import type { IWorkflowHistory } from 'types/IWorkflow';
import { fetchWorkflowHistory, submitDrawing, approveDrawing, rejectDrawing } from 'store/actions/workflowActions';

export interface WorkflowState {
  history: IWorkflowHistory[];
  loading: boolean;
  error: string | null;
}

const initialState: WorkflowState = {
  history: [],
  loading: false,
  error: null,
};

const workflowReducer = createReducer<WorkflowState>(initialState, (builder) => {
  builder
    .addCase(fetchWorkflowHistory.pending, (state) => {
      state.loading = true;
      state.error = null;
    })
    .addCase(fetchWorkflowHistory.fulfilled, (state, action) => {
      state.loading = false;
      state.history = action.payload;
    })
    .addCase(fetchWorkflowHistory.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || 'Fehler beim Laden des Workflow-Verlaufs';
    })
    .addCase(submitDrawing.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(approveDrawing.fulfilled, (state) => {
      state.loading = false;
    })
    .addCase(rejectDrawing.fulfilled, (state) => {
      state.loading = false;
    });
});

export default workflowReducer;
